import { useQuery } from 'react-query';

import { META_CATEGORIES_QUERY_KEY } from '../api/apiConsts';
import { getMetaCategories } from '../api/meta-categories';
import { BaseQueryParams } from '../common/models/base-query-params';
import { ALL_PAGINATED_LIST_ITEMS_PARAMS } from '../common/utils/common';

export const useMetaCategories = (params: BaseQueryParams = ALL_PAGINATED_LIST_ITEMS_PARAMS) => {
  return useQuery([META_CATEGORIES_QUERY_KEY], () => getMetaCategories(params), {
    staleTime: Infinity,
  });
};
